import Wrapper from './ProductsHeaders/Wrapper';
import Table from './ProductRequestsTable';

export default function () {
  return (
    <Wrapper topBarActiveOption={'Products'} active="product_requests">
      <div className="flex">
        <div className="w-full overflow-hidden">
          <Table />
        </div>
      </div>
    </Wrapper>
  );
}
